import React, { useMemo } from 'react';

export default function TopGainers({ tickers }) {
  const topGainers = useMemo(() => {
    return Object.values(tickers)
      .filter((t) => t.changePercent > 0)
      .sort((a, b) => b.changePercent - a.changePercent)
      .slice(0, 20);
  }, [tickers]);

  const openTradingView = (symbol) => {
    window.open(
      `https://www.tradingview.com/chart/?symbol=${symbol}&interval=1`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <div className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
      <div className="px-4 sm:px-6 py-4 border-b border-gray-100">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-900">Top Gainers</h2>
          <span className="text-xs text-gray-400">{Object.keys(tickers).length} tickers tracked</span>
        </div>
      </div>

      {topGainers.length === 0 ? (
        <div className="px-4 sm:px-6 py-12 text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gray-100 mb-3">
            <svg className="w-6 h-6 text-gray-400 animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
            </svg>
          </div>
          <p className="text-sm text-gray-500">Waiting for market data...</p>
          <p className="text-xs text-gray-400 mt-1">Data streams during market hours (4:00 AM - 8:00 PM ET)</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                <th className="px-4 sm:px-6 py-3 bg-gray-50">Ticker</th>
                <th className="px-4 sm:px-6 py-3 bg-gray-50 text-right">Price</th>
                <th className="px-4 sm:px-6 py-3 bg-gray-50 text-right">Change %</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {topGainers.map((ticker) => (
                <tr
                  key={ticker.sym}
                  onClick={() => openTradingView(ticker.sym)}
                  className="hover:bg-violet-50 active:bg-violet-100 cursor-pointer transition-colors"
                >
                  <td className="px-4 sm:px-6 py-3.5">
                    <span className="text-sm font-semibold text-gray-900">{ticker.sym}</span>
                  </td>
                  <td className="px-4 sm:px-6 py-3.5 text-right">
                    <span className="text-sm text-gray-700 font-medium tabular-nums">
                      ${ticker.price.toFixed(2)}
                    </span>
                  </td>
                  <td className="px-4 sm:px-6 py-3.5 text-right">
                    <span className="inline-flex items-center gap-1 text-sm font-semibold text-green-600 tabular-nums">
                      <svg className="w-3.5 h-3.5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 17a.75.75 0 01-.75-.75V5.612L5.29 9.77a.75.75 0 01-1.08-1.04l5.25-5.5a.75.75 0 011.08 0l5.25 5.5a.75.75 0 11-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0110 17z" clipRule="evenodd" />
                      </svg>
                      +{ticker.changePercent.toFixed(2)}%
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
